/* global $:true */
import debug from "debug";
import plugin from '../../lib/plugin';

export const ELEMENT_SELECTOR = '[data-countdown-timer]';
export const PLUGIN_NAME = 'countdownTimer';
export const MODULE_NAME = 'module/coundown-timer';
const log = debug(MODULE_NAME);


export function exec() {
	const elements = $(ELEMENT_SELECTOR).toArray();
	if (!elements || !elements.length) { return; }
	const { CountdownTimer } = require('./component');
	plugin(PLUGIN_NAME, CountdownTimer);
    $(elements)[PLUGIN_NAME]();
	log('Initialized ' + PLUGIN_NAME);
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/countdown-timer/index.js